import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-ospedale',
  templateUrl: './sidebar-ospedale.component.html'
})
export class SidebarOspedaleComponent { }
